import { render, staticRenderFns } from "./sharedVenueList.vue?vue&type=template&id=163a1d8c&scoped=true&"
import script from "./sharedVenueList.vue?vue&type=script&lang=js&"
export * from "./sharedVenueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a1d8c",
  null
  
)

export default component.exports